import React from 'react';
import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';
import InputControl from 'components/InputControl';

const InputFormControl = ({
  id,
  label,
  name,
  defaultValue,
  error,
  control,
}) => (
  <>
    {control && (
      <Controller
        name={name}
        defaultValue={defaultValue}
        control={control}
        render={({ onChange, value }) => (
          <InputControl
            id={id}
            label={label}
            error={!!error}
            helperText={error || null}
            onChange={onChange}
            value={value}
          />
        )}
      />
    )}
  </>
);

InputFormControl.defaultProps = {
  name: null,
  defaultValue: '',
  error: '',
  control: null,
};

InputFormControl.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  name: PropTypes.string,
  defaultValue: PropTypes.string,
  error: PropTypes.string,
  control: PropTypes.shape(),
};

export default InputFormControl;
